__turbopack_context__.v({
  "book-deals": "InterestPageHeader-module__UJt0bG__book-deals",
  "header-title": "InterestPageHeader-module__UJt0bG__header-title",
  "headerCopy": "InterestPageHeader-module__UJt0bG__headerCopy",
  "interest-page-header": "InterestPageHeader-module__UJt0bG__interest-page-header",
  "loader": "InterestPageHeader-module__UJt0bG__loader",
  "read-more-button": "InterestPageHeader-module__UJt0bG__read-more-button",
  "title": "InterestPageHeader-module__UJt0bG__title",
});
